<template>
  <div class="custom-tree-node custom-node-line" :class="{'findErr':error}">
    <div :class='["custom-content",!isHiddenRelation && relations && relations.length > 0 ?"custom-have-cr" :""]'>
      <div class="custom-flex" :class="{'hasErr':error}">
        <div class="deleteBtn" @click="deleteCondition">
          <div class="deleteBar"></div>
        </div>
        <!-- 二级列表选择器 -->
        <condition-name class="mr-10" v-if="!isSelect" ref="conName" @getDateName="setDataName" @change="selectName" />

        <!-- 有下拉框类型 -->
        <div class="condition-relation-box mr-10" v-if="dataName&&relations && relations.length" :key="refreshKey">
          <el-select v-model="relationsVal" size="small" placeholder="请选择条件" @change="onChangeRelation" @blur="blur" @focus="focus">
            <el-option v-for="item in relations" :key="item.id" :label="item.screenText||item.label" :value="item.screenType||item.value" />
          </el-select>
        </div>

        <!-- 手动添加 -->
        <input-render ref='inputRender' v-if="conditionType" v-model="inputValue" :key="refreshKey+2" :options="inputOptions" :num="conditionType" :type="inputType[conditionType]" :glId="glId"
         :error="error" @change="onChangeValue" />
         <span class="advancedCopyBtn" v-if="conditionType == 4 && inputValue.length"><i class="el-icon-document-copy copy-icon" @click.stop="copyTagValue(inputValue,conditionType)"></i></span>
        <transition name="el-fade-in-linear">
          <span class="error-warn" v-if="error">{{errorText}}</span>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import inputRender from './inputRender'
import conditionName from './conditionName'
import _isEmpty from 'lodash/isEmpty'
import uniqueId from 'lodash/uniqueId'
import { selectOptions } from '../api/newClueApi'
import mixin from './stopon.js'
export default {
  mixins: [mixin],
  name: 'customTreeNode',
  components: {
    inputRender,
    conditionName
  },
  props: {
    index: Number,
    data: Object,
    firstIndex: String,
    isSelect: Boolean,
    filterArr: Array,
  },
  data() {
    return {
      refreshKey: 0,
      conditionType: '',
      inputType: {
        1: 'select',
        2: 'select',
        3: 'multi',
        4: 'enter',
        5: 'number',
        6: 'data',
        8: 'mapped',
        9: 'area',
        10:'number',
        11: 'multiTree',
      },
      inputOptions: [],
      inputValue: [],
      conditionName: [],
      relations: [],
      relationsVal: '',
      placeholder: null,
      unit: null,
      prefix: null,
      isHiddenRelation: false,

      // 未知
      resultCN: null,

      error: '',
      errorText: '请完善查询条件',
      dataName: '',
      isFocus: false,//是否聚焦
      glId:0,//关联ID
      wordArr:[],//接收输入的标签 判断输入的标签是否有重复 有重复项不进行本地存储
    }
  },
  // inputValue
  watch: {
    inputValue: {
      deep: true,
      handler(value) {
        this.onChangeValue(value)
      }
    },
    '$store.state.advancedSearch.hasErr': {
      handler(val) {
        if (val) {
          this.error = this.data.err
          setTimeout(() => { //延迟刷新
            this.data.err = false
          })
        }
      }
    }

  },
  mounted() {
    this.$nextTick(() => {
      this.data.conditionId && this.selectOptions(this.data.conditionId, true)
    })
  },

  methods: {
    copyTagValue(arr,type){
        let arrval = []
        if(arr){
            arr.forEach(v => {
              arrval.push(v.label)
            });
        }
        arrval = arrval.join('、')
         this.$copyText(arrval).then(()=>{
            this.$message.success('复制成功')
         }).catch(()=>{
            this.$message.fail('复制失败')
         })
    },
    deleteCondition() {
      // 通知条件组，删除节点
      this.$emit('delete', this.index, this.firstIndex)
      
      this.getSetDefaultCondition()
    },
    clearErr() {
      this.error = false
    },
    selectName(value) {
      this.selectOptions(value.id)
      this.clearErr()
    },
    async selectOptions(id, edit) {
      this.$parent.$parent.$parent.loading = true
      const { data } = await selectOptions({ id })
      data.optionVos = data.optionVos || []
      this.$parent.$parent.$parent.loading = false
      this.refreshKey++
      // conditionType	筛选类型 1：有无 下拉框；2 时间/是否下拉框；3：复选框；4：输入框；5：四舍五入数字范围；6：日期范围选择；7：小数范围输入
      this.setData(data, edit)
    },

    setData(data, edit) {
      this.glId = data.id
      this.conditionType = data.conditionType
      this.inputOptions = data.optionVos
      this.data.screenTypeText = data.keyword

      // 编辑模式回显，否则向源数据赋值
      if (edit) {
        this.relations = this.data.includeTypes || data.includeTypes
        this.relationsVal = String(this.data.screenType)
        // this.inputValue = [...this.data.values]
        this.inputValue = [...this.data.conditionValues]
      } else {
        this.relations = data.includeTypes
        this.relationsVal = (data.includeTypes[0] || {}).screenType

        this.data.conditionId = data.id
        this.data.conditionType = data.conditionType
        this.data.screenType = this.relationsVal
        // this.data.values = []
        this.data.conditionValues = []

        // 1 || 2 是一级下拉多选 默认赋值
        if (data.conditionType === 1 || data.conditionType === 2) { 
          this.inputValue = [this.inputOptions[0].value]
        } else {
          this.inputValue = []
        }

      }

      this.setDataName(this.data.screenTypeText)
      this.$nextTick(e => {
        this.$refs.conName && this.$refs.conName.init(this.data.screenTypeText)
      })
    },


    onChangeValue(value) {
      let flag = false
      if(value && typeof value == 'string'){
        
        if(this.wordArr.length){
         flag = this.wordArr.includes(value)
          if(!flag){
            this.wordArr.push(value)
          }
        }else{
          this.wordArr.push(value)
        }
      }
      // 条件值变化，通知条件组更新
      this.data.conditionValues = [...value]
      this.clearErr()

      if(flag) return
      this.getSetDefaultCondition()
    },
    onChangeRelation(value) {
      // 条件变化，通知条件组更新
      this.data.screenType = value
      this.clearErr()
      
      this.getSetDefaultCondition()
    },
    setDataName(value) {
      this.dataName = value
    },
    // 本地存储默认条件
    getSetDefaultCondition(){
      let source = this.$store.getters.getDefaultCondition
      localStorage.setItem('inputDefaultCondition',JSON.stringify(source),1)
    }
  },
}
</script>

<style lang="scss">
.custom-tree-node {
  padding-top: 8px;
  padding-bottom: 8px;
}
.custom-content {
  display: inline-block;
  padding: 4px;
  font-size: 0;
  position: relative;
  padding-right: 40px;
  left: 20px;
  > div.custom-flex {
    display: flex;

    .deleteBtn {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      background: #fff;
      border: 2px solid #5088FF;
      border-radius: 50% 50%;
      margin-right: 8px;
      display: inline-block;
      cursor: pointer;
      position: relative;
      left: 0;
      top: 8px;
      .deleteBar {
        width: 8px;
        height: 2px;
        background: #5088FF;
        position: absolute;
        top: 5px;
        left: 2px;
      }
    }
  }
}
.custom-child {
  .error-warn {
    color: #f5222d;
    padding-top: 4px;
    float: left;
    font-size: 12px;
    position: absolute;
    top: 35px;
    left: 30px;
  }
  .hasErr input {
    border-color: #f04134 !important;
    box-shadow: 0px 0px 4px 0px rgba(240, 65, 52, 0.4);
  }
  .hasErr .tag-input {
    border-color: #f04134 !important;
    box-shadow: 0px 0px 4px 0px rgba(240, 65, 52, 0.4);
  }
}

.no-border-left {
  .normal-border {
    border-left: none;
  }
}
.node-more {
  font-size: 14px;
  height: 28px;
  line-height: 28px;
  color: #ff9052;
  padding-left: 16px;
  cursor: pointer;
}
.node-forbit {
  color: #bfbfbf;
  cursor: not-allowed;
}
.custom-content {
  .el-cascader {
    width: 174px;
  }
  .condition-relation {
    width: 82px;
    .el-icon-arrow-up {
      transform: none !important;
      position: relative;
      left: 4px;
      &::before {
        content: "\E790";
      }
    }
  }
  .condition-name-select {
    .condition-relation {
      width: 120px;
    }
  }
}
.condition-relation {
  .el-input__inner {
    border-radius: 0;
    font-size: 12px;
    padding: 0 4px;
  }
}
.condition-name-select {
  position: relative;
}
.condition-relation-box {
  position: relative;
  width: 160px;
  // width: 104px;
  .popper__arrow {
    display: none;
  }
  .el-popper {
    left: 0px !important;
    margin-top: 4px !important;
  }
}
.no-right-border {
  .el-input__inner {
    border-right: none;
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
  background: none !important;
}
.select-option {
  .popper__arrow {
    display: none;
  }
  .el-select-dropdown__item.selected {
    background: none;
  }
  .el-select-dropdown__item.hover {
    background: none !important;
  }
  .el-select-dropdown__item:hover {
    background-color: transparent;
  }
  .el-select-dropdown__item {
    padding: 0 12px;
    max-width: 360px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.custom-group{
        .el-input--small .el-input__inner{
           height: 36px;
           line-height: 36px;
           box-shadow: none;
           font-size: 13px;
        }
    }
.advancedCopyBtn{
 font-size: 16px;
 line-height: 36px;
 margin-left: 10px;
 .copy-icon{
    cursor: pointer;
    transition: all 0.3s;
    &:hover{
      color: #5088FF;
    }
 }
}  
</style>